export default __webpack_public_path__ + "static/media/97bd13_df838d09ffc74feaa31434290814ce58mv2.8712a061.jpg";